var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12.9384L13.5155 20.9644C12.5251 21.9476 11.1818 22.5 9.78116 22.5C8.38051 22.5 7.03723 21.9476 6.04682 20.9644C5.05641 19.9811 4.5 18.6476 4.5 17.2571C4.5 15.8665 5.05641 14.533 6.04682 13.5497L14.1313 5.52375C14.7916 4.86825 15.6871 4.5 16.6209 4.5C17.5546 4.5 18.4502 4.86825 19.1104 5.52375C19.7707 6.17924 20.1416 7.06829 20.1416 7.9953C20.1416 8.92231 19.7707 9.81135 19.1104 10.4668L11.0171 18.4928C10.687 18.8206 10.2393 19.0047 9.77237 19.0047C9.30548 19.0047 8.85772 18.8206 8.52759 18.4928C8.19745 18.1651 8.01198 17.7206 8.01198 17.2571C8.01198 16.7935 8.19745 16.349 8.52759 16.0213L15.9963 8.61537",
    stroke: "#929298",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.9ac2aeda9446e3f1df4ea7e80f6f2c5a.svg";
export { ForwardRef as ReactComponent };